import { Component, Input } from "@angular/core";

@Component({
  template: ''
})
export class BaseControl {
  /**
   * Variable which is used to store the input type.
   * @type{string}.
   */
  @Input() type!: string;
  /**
   * Variable which is used to store the input control id.
   * @type{string | number}.
   */
  @Input() id!: string | number;
  /**
   * Variable which is used to store the input control name.
   * @type{string | number}.
   */
  @Input() name!: string | number;
  /**
   * Variable which is used to store the input control value.
   * @type{string | number | boolean}.
   */
  @Input() value!: any;
  /**
   * Variable which is used to store the input control disabled status.
   * @type{boolean}.
   */
  @Input() disabled!: boolean;
  /**
   * Variable which is used to store the input control validation pattern.
   * @type{string}.
   */
  @Input() pattern!: string;
  /**
   * Variable which is used to set the read only property.
   * @type{boolean}.
   */
  @Input() readonly!: boolean;
  /**
   * Variable which is used to store the place holder of the control.
   * @type{string | number}.
   */
  @Input() placeholder!: string | number;
  /**
   * Variable which is used to store a text of the control.
   * @type { string }
   */
  @Input() text!: string;
  /**
   * Variable which is used to store a value of the icon name.
   * @type { string }
   */
  @Input() icon!: string;
  /**
   * Variable which is used to store a value of icon type.
   * @type { string }
   */
  @Input() iconType!: string;
}